<template>
  <div v-if="selectedInspection && commonData" class="inspection-planning-screen">
    <div class="row">
      <div class="row mt-20 mb-20 ml-5">
        <div class="col-sm-6">
          <h3>{{title}}</h3>
        </div>
      </div>
      <div class="col-md-12">
        <div class="panel panel-default border-panel card-view">
          <div class="panel-wrapper collapse in">
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-wrap">
                    <form action="#" class="form-horizontal" @keydown="handleKeyDown($event)">
                      <div class="form-body">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <div class="col-md-12">
                                <form-input
                                  v-model="inspectionName"
                                  :type="'text'"
                                  labelClassNames="control-label mb-10 text-left"
                                  classNames="form-control rounded"
                                  :placeholder="$t(`app.inspections.attributes_placeholders.name`)"
                                  :labelValue="$t(`app.inspections.attributes.name`)"
                                  :validationMethod="nameValidation"
                                  :inputDisabled="!hasPermission"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <div class="col-md-12">
                                <base-dropdown
                                  v-model="responsibleUserId"
                                  :defaultValue="selectedInspection.responsible_user_id"
                                  :list="responsibleUserList"
                                  labelClassNames="control-label mb-10 text-left"
                                  :labelValue="$t(`app.inspections.attributes.responsible_user_id`)"
                                  :inputDisabled="!hasPermission"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" style="display: flex; align-items: center;">
                          <div class="col-md-8">
                            <div class="form-group">
                              <div class="col-md-12">
                                <label
                                  class="control-label mb-10 text-left"
                                >{{ $t(`app.inspections.attributes.inspection_participants`) }}</label>
                                <multiselect v-model="selectedInspectionParticipants"
                                  :options="inspectionParticipants"
                                  :disabled="!hasPermission"
                                  :multiple="true"
                                  :selectLabel="$t('app.multiselect.select')"
                                  :selectedLabel="$t('app.multiselect.selected')"
                                  :deselectLabel="$t('app.multiselect.remove')"
                                  :close-on-select="false"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  :placeholder="$t(`app.inspections.attributes_placeholders.inspection_participants`)"
                                  label="name"
                                  track-by="id"
                                  :preselect-first="false"
                                  @input="item => selectedInspectionParticipants = item">
                                  <span slot="noOptions">{{$t('app.generals.empty_list')}}</span>
                                  <template #noResult>
                                    {{$t('app.generals.empty_list')}}
                                  </template>
                                  </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                                <DateTimePicker
                                  v-model="dateOfMaturity"
                                  :disabled="!hasPermission"
                                  customClass="date-picker"
                                />
                              </div>
                        </div>
                        <div class="row">
                          <div class="col-md-8">
                            <div class="form-group">
                              <div class="col-md-12">
                                <label
                                  class="control-label mb-10 text-left"
                                >{{ $t(`app.inspections.attributes.specialization_id`) }}</label>
                                <multiselect v-model="selectedSpecializations"
                                  :options="specializations"
                                  :multiple="true"
                                  :selectLabel="$t('app.multiselect.select')"
                                  :selectedLabel="$t('app.multiselect.selected')"
                                  :deselectLabel="$t('app.multiselect.remove')"
                                  :close-on-select="false"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  :placeholder="$t(`app.inspections.attributes.specialization_id`)"
                                  label="name"
                                  track-by="id"
                                  :preselect-first="false"
                                  :disabled="!hasPermission"
                                  @input="specSelected">
                                  <span slot="noOptions">{{$t('app.generals.empty_list')}}</span>
                                  <template #noResult>
                                    {{$t('app.generals.empty_list')}}
                                  </template>
                                  </multiselect>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <div class="col-md-12">
                                <div class="card-dropdown">
                                  <div class="panel panel-default contact-card card-view">
                                    <div class="bg-white">
                                      <div class="row card-row">
                                        <div class="col-md-2">
                                          <div class="user-img-wrap">
                                            <i class="circle">
                                              <img class="icon" src="static/home.png">
                                            </i>
                                          </div>
                                        </div>
                                        <div class="col-md-10 decreased-padding">
                                          <label
                                            class="control-label mb-10 text-left"
                                          >{{ $t(`app.inspections.attributes.location_ids`) }}</label>
                                          <multiselect v-model="selectedLocations"
                                          :options="locations"
                                          :noOptionsText="'hu'"
                                          :multiple="true"
                                          :selectLabel="$t('app.multiselect.select')"
                                          :selectedLabel="$t('app.multiselect.selected')"
                                          :deselectLabel="$t('app.multiselect.remove')"
                                          :close-on-select="false"
                                          :clear-on-select="false"
                                          :preserve-search="true"
                                          :placeholder="$t(`app.inspections.attributes_placeholders.location_ids`)"
                                          label="name"
                                          track-by="id"
                                          :preselect-first="false"
                                          :disabled="!hasPermission"
                                          @input="optionSelected">
                                          <span slot="noOptions">{{$t('app.generals.empty_list')}}</span>
                                          <template #noResult>
                                            {{$t('app.generals.empty_list')}}
                                          </template>
                                        </multiselect>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--/span-->
                          <div class="col-md-4">
                            <div class="form-group row">
                              <div class="col-md-12">
                                <card-dropdown
                                  :imagePath="'static/categories.png'"
                                  :list="categoryList"
                                  labelClassNames="control-label mb-10 text-left"
                                  classNames="form-control rounded"
                                  :placeholder="$t(`app.inspections.attributes_placeholders.criteria_category_id`)"
                                  :labelValue="$t(`app.inspections.attributes.criteria_category_id`)"
                                  v-model="selectedCategory"
                                  :defaultValue="selectedCategory"
                                  @input="categoryChanged('category')"
                                  :inputDisabled="!hasPermission"
                                />
                              </div>
                            </div>
                          </div>
                          <!--/span-->
                          <div class="col-md-4">
                            <div class="form-group row">
                              <div class="col-md-12">
                                <card-dropdown
                                  :imagePath="'static/categories.png'"
                                  :list="subCategoryList"
                                  labelClassNames="control-label mb-10 text-left"
                                  classNames="form-control rounded"
                                  :placeholder="$t(`app.inspections.attributes_placeholders.criteria_category_id`)"
                                  :labelValue="$t(`app.inspections.attributes.sub_criteria_category_id`)"
                                  v-model="selectedSubCategory"
                                  :defaultValue="selectedSubCategory"
                                  @input="categoryChanged('subCategory')"
                                  :inputDisabled="!hasPermission"
                                />
                              </div>
                            </div>
                          </div>
                          <!--/span-->
                          <div class="col-md-4">
                            <div class="form-group">
                              <div class="col-md-12">
                                <card-checkbox
                                  :inputDisabled="!hasPermission"
                                  :imagePath="'static/calendar.png'"
                                  :list="maturityList"
                                  @valueChanged="checkboxesChanged"
                                />
                              </div>
                            </div>
                          </div>
                          <!--/span-->
                        </div>
                        <div class="row location-row">
                          <div class="col-md-4 location-order">
                            <h6 class="location-order-label">
                              <span class="panel-title text-dark">
                                {{$t('app.inspections.site_order')}}
                              </span>
                            </h6>
                            <draggable :disabled="!hasPermission" v-if="selectedLocations.length > 0" v-model="selectedLocations" class="list-group" group="people" @start="drag=true" @end="drag=false">
                              <div class="list-group-item" v-for="(element,index) in selectedLocations" :key="element.id">
                                <i class="ti-menu"/>
                                  {{element.name}}
                                  <span class="badge">{{index + 1}}</span>
                              </div>
                            </draggable>
                            <span v-if="selectedLocations.length === 0"></span>
                          </div>
                        </div>
                        <div class="mb-15"></div>
                        <configurable-list
                          v-if="allStatement && statementPerPage"
                          :hasSearch="hasPermission"
                          :searchLabel="$t('app.statements.search_input_placeholder')"
                          :hasCheckbox="hasPermission"
                          :data="statementPerPage"
                          :fields="statementFields"
                          :selection="selectedStatementIds"
                          @search="search"
                          @selectionChanged="selectionChanged"
                          @checkAll="checkAll"
                        />
                        <paginator-component
                          v-if="storedStatements"
                          :totalPages="Math.ceil(storedStatements.length / 8)"
                          :currentPageIndex="currentPageIndex"
                          @itemSelected="itemSelected"
                        />
                        <div class="row info-row with-padding">
                          <div class="col-sm-8">
                            <div class="col-sm-3 info">
                              <span>{{$t("app.dashboard.all_category")}}:</span>
                            </div>
                            <div class="col-sm-1 info-value">
                              <span>{{ this.categoriesCount }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="row info-row">
                          <div class="col-sm-8">
                            <div class="col-sm-3 info">
                              <span>{{$t("app.dashboard.statements")}}:</span>
                            </div>
                            <div class="col-sm-1 info-value">
                              <span>{{ selectedStatementIds.filter(x => x).length }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="row info-row">
                          <div class="col-sm-8">
                            <div class="col-sm-3 info">
                              <span>{{$t('app.inspections.expected_duration')}}</span>
                            </div>
                            <div class="col-sm-2">
                              <span>{{Math.round(this.timeRange)}} {{$t('app.inspections.minute')}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="seprator-block"></div>
                      </div>
                      <div v-if="hasPermission" class="form-actions mt-10">
                        <div class="row pull-right">
                          <div class="col-md-12">
                            <div class="row pull-right">
                              <div class="col-md-12">
                                <base-button
                                  classNames="btn btn-orange mr-10"
                                  :title="$t(`app.inspections.submit`)"
                                  @clicked="submit"
                                />

                                <base-button
                                  classNames="btn btn-default"
                                  :title="$t(`app.inspections.cancel`)"
                                  @clicked="cancel"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';

import { mapActions, mapGetters } from 'vuex';
import ConfigurableList from '@/components/shared/lists/ConfigurableList';
import BaseButton from '@/components/shared/buttons/BaseButton';
import SearchInput from '@/components/shared/inputs/SearchInput';
import FormInput from '@/components/shared/inputs/FormInput';
import BaseDropdown from '@/components/shared/inputs/BaseDropDown';
import CardDropDown from '@/components/shared/inputs/CardDropDown';
import CardCheckbox from '../../shared/inputs/CardCheckbox';
import Paginator from '@/components/shared/navigations/Paginator';
import draggable from 'vuedraggable';
import DateTimePicker from '@/components/shared/inputs/DateTimePicker';

export default {
  name: 'InspectionPlanningScreen',
  components: {
    'base-button': BaseButton,
    'search-input': SearchInput,
    'configurable-list': ConfigurableList,
    'form-input': FormInput,
    'base-dropdown': BaseDropdown,
    'card-dropdown': CardDropDown,
    'card-checkbox': CardCheckbox,
    'vue-tags-input': VueTagsInput,
    'paginator-component': Paginator,
    draggable,
    DateTimePicker
  },
  props: {},
  data() {
    return {
      myArray: [
        {
          name: 'Juan 4',
          id: 4,
        },
        {
          name: 'Edgard',
          id: 3,
        },
      ],
      multiSelectValue: [],
      selectedInspection: {},
      selectedInspectionParticipants: [],
      location: undefined,
      selectedLocations: [],
      selectedCategory: undefined,
      selectedSubCategory: undefined,
      selectedStatementIds: [],
      storedStatements: [],
      // inspectionIdentifier: "",
      inspectionName: '',
      dateOfMaturity: undefined,
      hasTask: false,
      matureSoon: false,
      currentPageIndex: 1,
      searchTerm: '',
      title: '',
      responsibleUserId: undefined,
      maturityList: [],
      timeRange: 0,
      selectedCategories: [],
      uniqCategories: [],
      categoriesCount: 0,
      sites: [],
      siteId: undefined,
      selectedSpecializations: [],
      siteLocations: [],
      selectedSite: undefined,
      allsite: [],
      responsibleUserList: [],
      locations: [],
    };
  },
  created() {
    this.$eventBus.showLoading(this.$t('app.inspections.inspectionLoading'));
    this.maturityList = [
      this.$t('app.inspections.maturity_list_with_task'),
      this.$t('app.inspections.maturity_list_soon'),
    ];
    this.fetchSites({
      partnerId: this.loggedInUser.partner_id,
      pageIndex: null,
      searchTerm: '',
      orderInfo: {
        order: 'created_at',
        direction: 'ASC',
      },
      isMobile: true,
    }).then((response) => {
      this.allsite = response;
      this.sites = response.filter(x => x.base_state_status === 'finalized').map(x => ({ value: x.id, text: this.$t(x.name) }));
      if (this.$route.query.siteId !== undefined && this.$route.query.siteId !== null && this.$route.query.siteId !== '') {
        this.selectedSite = response.filter(x => x.id.toString() === this.$route.query.siteId.toString())[0];
        this.siteId = this.$route.query.siteId;
        this.siteLocations = response.map(x => ({
          siteId: x.id,
          locations: x.locations,
        }));
      }
      if (this.isNewInpsection) {
        this.title = this.$t('app.inspections.create_inspection');
        this.selectedSpecializations = this.loggedInUser.specializations.map(
          x => ({ name: this.$t(`app.specializations.${x.name}`), id: x.id }),
        );
        this.setResponsibleUserList();
        this.setLocations();
        this.fetchStatements({
          needAll: true,
          siteId: this.siteId,
          specializations: this.selectedSpecializations.map(x => x.id),
          locationIds: this.selectedLocations.map(x => x.id),
        }).then((r) => {
          this.storedStatements = r;
          this.$eventBus.hideLoading({});
        });
      } else {
        this.fetchInspection({ id: this.$route.params.id, withDeleted: false }).then((inspection) => {
          this.siteId = inspection.site_id;
          if (this.$route.query.siteId === undefined || this.$route.query.siteId === null || this.$route.query.siteId === '') {
            this.selectedSite = response.filter(x => x.id.toString() === this.siteId.toString())[0];
            this.siteLocations = response.map(x => ({
              siteId: x.id,
              locations: x.locations,
            }));
          }
          this.selectedSite = this.allsite.filter(x => x.id === this.siteId)[0];
          this.selectedInspection = inspection;
          this.dateOfMaturity = new Date(this.selectedInspection.date_of_maturity);
          this.inspectionName = this.selectedInspection.name;
          this.responsibleUserId = this.selectedInspection.responsible_user_id;
          inspection.inspections_statements.forEach((inspectionStatement) => {
            this.selectionChanged(inspectionStatement.statement, true);
          });
          this.selectedSpecializations = this.loggedInUser.specializations.map(
            x => ({ name: this.$t(`app.specializations.${x.name}`), id: x.id }),
          );
          let savedLocations = [];
          const savedIds = [];
          inspection.inspections_statements.forEach((inspectionStatement) => {
            savedLocations = savedLocations.concat(inspectionStatement.statement.locations.map((x) => {
              if (!savedIds.includes(x.id)) {
                savedIds.push(x.id);
                return { name: x.name, id: x.id };
              }
            }));
          });
          savedLocations = savedLocations.filter(x => x !== undefined);
          this.optionSelected(savedLocations);
          this.selectedInspectionParticipants = inspection.participants.map(
            x => ({ name: x.name, id: x.id }),
          );
          this.setResponsibleUserList();
          this.fetchStatements({
            needAll: true,
            siteId: this.siteId,
            specializations: this.selectedSpecializations.map(x => x.id),
            locationIds: this.selectedLocations.map(x => x.id),
          }).then((r) => {
            this.setLocations();
            this.$eventBus.hideLoading({});
            this.storedStatements = r;
          });
        });
        this.title = 'Szemle szerkesztése';
      }
    });
  },
  computed: {
    ...mapGetters({
      storedInspection: 'inspections/selectedInspection',
      allStatement: 'statements/allStatements',
      commonData: 'partners/commonData',
      loggedInUser: 'loggedInUser',
    }),
    hasPermission() {
      return this.loggedInUser.role !== 'vivu';
    },
    statementFields() {
      return [
        {
          title: this.$t('app.tables.inspectionPlanning.identifier'),
          cellClass: 'identifier-cell',
          key: 'identifier',
          isLink: true,
          historyPath: true,
          route_path: 'criteria_categories',
        },
        {
          title: this.$t('app.tables.inspectionPlanning.question'),
          cellClass: 'question-cell',
          key: 'verification_question_name',
        },
        {
          title: this.$t('app.tables.inspectionPlanning.statement'),
          cellClass: 'statement-cell',
          key: 'statement',
        },
        {
          title: this.$t('app.navigation.partner_navbar.sites'),
          cellClass: 'location-cell',
          arrayAttribute: 'name',
          key: 'locations',
        },
        {
          title: this.$t('app.tables.inspectionPlanning.lastInspection'),
          key: 'last_inspection',
          cellClass: 'last-inpection-cell',
          class: 'tag',
          subClass: 'maturity_badge',
        },
      ];
    },
    statementPerPage() {
      return this.paginateList(this.storedStatements, 8, this.currentPageIndex);
    },
    totalPages() {
      return this.allStatement.total_pages || 0;
    },
    isNewInpsection() {
      return !this.$route.params.id;
    },
    inspectionParticipants() {
      let array = [];
      if (this.selectedSite === undefined || this.selectedSite.participants.length === 0) {
        return array;
      }
      this.selectedSite.participants.forEach((element) => {
        const object = { name: `${element.name} - ${this.$t(`app.roles.${element.role}`)}`, id: element.id };
        array = array.concat(object);
      });
      return array;
    },
    specializations() {
      let array = [];
      if (this.loggedInUser === undefined) {
        return array;
      }
      this.loggedInUser.specializations.forEach((element) => {
        const object = { name: this.$t(`app.specializations.${element.name}`), id: element.id };
        array = array.concat(object);
      });
      return array;
    },
    categoryList() {
      if (!this.commonData || !this.commonData.criteria_category_list) {
        return [];
      }
      const mappedCategories = this.commonData.criteria_category_list.filter(category => category.parent_id === null).map(
        category => ({
          value: category.id,
          text: category.name,
        }),
      );
      return mappedCategories;
    },
    subCategoryList() {
      if (!this.commonData || !this.commonData.criteria_category_list) {
        return [];
      }
      const mappedCategories = this.commonData.criteria_category_list.filter(category => category.parent_id !== null).map(
        category => ({
          value: category.id,
          text: category.name,
        }),
      );
      return mappedCategories;
    },
  },
  methods: {
    ...mapActions({
      fetchInspection: 'inspections/fetchInspection',
      fetchStatements: 'statements/fetchStatements',
      createInspection: 'inspections/createInspection',
      updateInspection: 'inspections/updateInspection',
      fetchSites: 'sites/fetchSites',
    }),
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    },
    setLocations() {
      const selectedSiteLocations = this.siteLocations.filter(loc => loc.siteId.toString() === this.siteId.toString());
      let array = [];
      if (selectedSiteLocations.length === 0) {
        return array;
      }
      selectedSiteLocations[0].locations.forEach((element) => {
        const object = { name: element.name, id: element.id };
        array = array.concat(object);
      });
      this.locations = array;
      return array;
    },
    setResponsibleUserList() {
      let array = [];
      if (this.selectedSite === undefined || this.selectedSite.participants.length === 0) {
        return array;
      }
      this.selectedSite.participants.forEach((element) => {
        const object = { text: `${element.name} - ${this.$t(`app.roles.${element.role}`)}`, value: element.id };
        array = array.concat(object);
      });
      this.responsibleUserList = array;
      return array;
    },
    specSelected(item) {
      this.selectedSpecializations = item;
      this.search(this.searchTerm);
    },
    filterBySite() {
      this.selectedSite = this.allsite.filter(x => x.id === this.siteId)[0];
      this.search(this.searchTerm);
    },
    itemSelected(index) {
      this.currentPageIndex = index;
    },
    optionSelected(value, id) {
      this.selectedLocations = value;
      this.search(this.searchTerm);
    },
    participantOptionsSelected(value, id) {
      this.selectedInspectionParticipants = value;
      this.search(this.searchTerm);
    },
    search(keyword) {
      this.searchTerm = keyword;
      this.currentPageIndex = 1;
      this.fetchStatements({
        needAll: true,
        searchTerm: this.searchTerm,
        locationIds: this.selectedLocations.map(x => x.id),
        categoryId: this.selectedCategory ? this.selectedCategory : this.selectedSubCategory,
        hasTask: this.hasTask,
        matureSoon: this.matureSoon,
        siteId: this.siteId,
        specializations: this.selectedSpecializations.map(x => x.id),
      }).then((response) => {
        this.storedStatements = response;
      });
    },
    locationsChanged(locations) {
      this.selectedLocations = locations;
      this.search(this.searchTerm);
    },
    locationsForList() {
      return this.commonData.location_list.map(location => ({
        id: location.id,
        text: location.name,
      }));
    },
    categoryChanged(type) {
      if(type === 'category') {
        this.selectedSubCategory = undefined
      } else {
        this.selectedCategory = undefined
      }
      this.search(this.searchTerm);
    },
    checkboxesChanged(values) {
      this.hasTask = values[0];
      this.matureSoon = values[1];
      this.search(this.searchTerm);
    },
    selectionChanged(data, value) {
      const distinct = (value, index, self) => self.indexOf(value) === index;
      let indexToRemove;
      if (value === true) {
        this.selectedCategories.push(data.criteria_category_id);
        this.uniqCategories = this.selectedCategories.filter(distinct);
        this.categoriesCount = this.uniqCategories.length;
        this.timeRange += data.average_time / 60;
      } else {
        this.selectedCategories.some((id, index) => {
          if (id === data.criteria_category_id) {
            indexToRemove = index;
            return true;
          }
        });
        this.selectedCategories.splice(indexToRemove, 1);
        this.categoriesCount = this.selectedCategories.filter(distinct).length;
        this.timeRange -= data.average_time / 60;
      }
      this.$set(this.selectedStatementIds, data.id, value);
    },
    checkAll(value) {
      this.allStatement.forEach((statement) => {
        if (value === true) {
          this.timeRange += statement.average_time / 60;
        } else {
          this.timeRange -= statement.average_time / 60;
        }
        this.$set(this.selectedStatementIds, statement.id, value);
      });
    },
    submit() {
      if (this.isNewInpsection) {
        this.createNewInspection();
      } else {
        this.updateExistingInspection();
      }
    },
    cancel() {
      this.$router.push('/inspections');
    },
    createNewInspection() {
      this.selectedInspection.location_order = [];
      this.selectedLocations.forEach((location, index) => {
        this.selectedInspection.location_order.push(location.id);
      });
      this.selectedInspection.statement_ids = [];
      this.selectedStatementIds.forEach((x, index) => {
        if (x === true) {
          this.selectedInspection.statement_ids.push(index);
        }
      });
      this.selectedInspection.participant_ids = this.selectedInspectionParticipants.map(
        x => x.id,
      );
      this.selectedInspection.name = this.inspectionName;
      this.selectedInspection.responsible_user_id = this.responsibleUserId;
      this.selectedInspection.date_of_maturity = new Date(this.dateOfMaturity);
      this.selectedInspection.site_id = this.siteId;
      //this.selectedInspection.specializations = this.selectedSpecializations.map(x => x.id);
      this.createInspection(this.selectedInspection)
        .then(() => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.inspections.create'),
            notificationType: 'success',
          });
          this.$router.push('/inspections');
        })
        .catch((errors) => {
          this.selectedStatementIds = [];
          this.selectedInspection.statement_ids = [];
          const mappedErrors = errors.map(x => ` ${x}`);
          const errorMessages = this.$t('app.errors.general_validation', {
            message: mappedErrors,
          });
          this.$swal
            .fire({
              html: errorMessages,
              type: 'error',
              showCloseButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false,
            });
        });
    },
    updateExistingInspection() {
      const sendableInspection = {};
      sendableInspection.id = this.selectedInspection.id;
      sendableInspection.statement_ids = [];
      this.selectedStatementIds.forEach((x, index) => {
        if (x === true) {
          sendableInspection.statement_ids.push(index);
        }
      });
      sendableInspection.participant_ids = this.selectedInspectionParticipants.map(
        x => x.id,
      );
      sendableInspection.name = this.inspectionName;
      sendableInspection.responsible_user_id = this.responsibleUserId;
      sendableInspection.date_of_maturity = new Date(this.dateOfMaturity);

      sendableInspection.location_order = [];
      this.selectedLocations.forEach((location, index) => {
        sendableInspection.location_order.push(location.id);
      });
      sendableInspection.site_id = this.siteId;
      //sendableInspection.specializations = this.selectedSpecializations.map(x => x.id);
      // eslint-disable-next-line no-unreachable
      this.updateInspection(sendableInspection)
        .then(() => {
          this.$router.push('/inspections');
        })
        .catch((errors) => {
          const mappedErrors = errors.map(x => ` ${x}`);
          const errorMessages = this.$t('app.errors.general_validation', {
            message: mappedErrors,
          });
          this.$eventBus.showNotification({
            notificationText: errorMessages,
            notificationType: 'danger',
          });
        });
    },
    indentifierValidation(value) {
      if (!value || value.length < 3) {
        return false;
      }
      return true;
    },
    nameValidation(value) {
      if (!value || value.trim() === '') {
        return false;
      }
      return true;
    },
    filteredList(list, tag) {
      return list.filter(i => i.text.toLowerCase().indexOf(tag.toLowerCase()) !== -1);
    },
    paginateList(array, page_size, page_number) {
      --page_number; // because pages logically start with 1, but technically with 0
      return array.slice(page_number * page_size, (page_number + 1) * page_size);
    },
  },
  watch: {
    currentPageIndex(newValue, oldValue) {
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>

.inspection-planning-screen {

  .date-picker {
    padding-top: 22px;
    /deep/ .mx-input-wrapper {
      input {
        border: 1px solid #e8e8e8;
        box-shadow: none;
        -webkit-box-shadow: none;
        height: 43px;
      }
    }
  }

  /deep/ .identifier-cell {
    width: 15%;
  }
  /deep/ .question-cell {
    width: 30%;
  }
  /deep/ .statement-cell {
    width: 29%;
  }
  /deep/ .last-inpection-cell {
    text-align: center;
    width: 10%;
  }
  /deep/ .location-cell {
    width: 12%;
  }

  .ti-menu {
    float: right;
    position: relative;
    top: 4px;
  }
  .badge {
    float: left;
    margin-right: 10px;
    background-color: var(--main-color);
    color: #ffffff;
  }

  .list-group-item {
    cursor: -webkit-grab;
    cursor: grab;
  }

  .location-row {
    margin-left: 0px;
    margin-right: 0px;
    border-bottom: 1px solid #eee;
  }
  .location-order {
    padding-left: 10px;
    margin-top: 10px;
    margin-bottom: 30px;
  }

  .list-group {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
  }

  .contact-card {
    min-height: 165px !important;
  }

  .circle {
    border-radius: 50%;
    border: 1px solid var(--main-color);
    text-align: center;
    display: inline-block;
    padding: 14px;
    height: 50px !important;
    width: 50px !important;
  }

  .icon {
    height: 20px !important;
    width: 20px !important;
  }

  .title {
    font-size: 28px;
    font-weight: normal;
  }

  .tag-0 {
    background: #f83f37;
    border-radius: 14px;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 0px 3px 0px;
    float: left;
    min-width: 85px;
    text-align: center;
  }

  .tag-1 {
    background: #ffbf36;
    border-radius: 14px;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 0px 3px 0px;
    float: left;
    min-width: 85px;
    text-align: center;
  }

  .tag-2 {
    background: #22af47;
    border-radius: 14px;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 0px 3px 0px;
    float: left;
    min-width: 85px;
    text-align: center;
  }

  label {
    font-size: 13px;
  }

  .info-row {
    padding-left: 15px;
  }

  .info {
    font-size: 13px;
    font-weight: bold;
  }

  .info-value {
    text-align: center;
  }

  .with-padding {
    padding-top: 20px;
  }
  .participants {
    max-width: 100% !important;
    & /deep/ .ti-input {
      border: none !important;
    }
    & /deep/ .ti-tag {
      background-color: var(--main-color) !important;
    }
    & /deep/ .ti-deletion-mark {
      background-color: #ee234f !important;
    }
    & /deep/ .ti-tag:before {
      display: none !important;
    }
    & /deep/ .ti-selected-item {
      background-color: var(--main-color) !important;
    }
  }

  &.vue-tags-input {
    height: auto !important;
  }
  & /deep/ .ti-input {
    border: none !important;
    input[type="text"] {
      font-family: 'Roboto', sans-serif !important;
    }
  }
  & /deep/ .ti-tag {
    background-color: var(--main-color) !important;
    .ti-tag-center {
      font-family: 'Roboto', sans-serif !important;
    }
  }
  & /deep/ .ti-deletion-mark {
    background-color: #ee234f !important;
  }
  & /deep/ .ti-tag:before {
    display: none !important;
  }
  // .card-row {
  //   height: 150px;
  // }

  /deep/ .multiselect__tag {
    background: var(--main-color);
  }

  /deep/ .multiselect__tag-icon:hover {
    background: var(--main-color);
  }

  /deep/ .multiselect__tag-icon:after {
    color: #000;
  }
}


/deep/ .multiselect__option--highlight:after {
  background: none;
}

/deep/ .multiselect__option--selected.multiselect__option--highlight:after {
  background: none;
}

/deep/ .multiselect__option--selected.multiselect__option--highlight {
    background: #ff282873 !important;
}

/deep/ .multiselect__option--highlight {
  background: #ff61289f;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inspections/InspectionPlanningScreen.vue